// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__8Nrzb","info":"UpdateTermsInfo_info__2UKY6"};